import { Check } from '@mui/icons-material';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { Button } from '../../../components';

export type TSizeRange =
  | 'companyBetween1and50'
  | 'companyBetween51and100'
  | 'companyBetween101and250'
  | 'companyBetween251and500'
  | 'companyBetween501and1000'
  | 'companyBetween1001and2000'
  | 'companyMoreThan2000';

export const sizeRanges: Array<{ key: TSizeRange; min: number; max?: number }> = [
  { key: 'companyBetween1and50', min: 0, max: 50 },
  { key: 'companyBetween51and100', min: 51, max: 100 },
  { key: 'companyBetween101and250', min: 101, max: 250 },
  { key: 'companyBetween251and500', min: 251, max: 500 },
  { key: 'companyBetween501and1000', min: 501, max: 1000 },
  { key: 'companyBetween1001and2000', min: 1001, max: 2000 },
  { key: 'companyMoreThan2000', min: 2001 },
];

export type TCompanySizeRangeDisplay = 'column' | 'grid' | 'row';

function SizeRangeForm({
  disabled,
  sizeRangeIndex,
  setSizeRangeIndex,
  display = 'row',
  heavyButton = false,
}: {
  disabled: boolean;
  setSizeRangeIndex: (index: number | null) => void;
  sizeRangeIndex: number | null;
  display?: TCompanySizeRangeDisplay;
  heavyButton?: boolean;
}): React.JSX.Element {
  const { t } = useTranslation();

  return (
    <Box
      alignItems={display === 'column' || display === 'grid' ? 'flex-start' : 'stretch'}
      columnGap={display === 'column' ? 0 : 1}
      display="flex"
      flexDirection={display === 'column' ? 'column' : 'row'}
      flexWrap={display === 'column' ? 'nowrap' : 'wrap'}
      rowGap={1}
      sx={{
        width: display === 'column' ? '100%' : 'auto',
      }}
    >
      {sizeRanges.map(({ key, min, max }, index) => {
        const active = index === sizeRangeIndex;

        return (
          <Button
            color="inherit"
            disabled={disabled}
            endIcon={active && <Check sx={{ color: '#2AC682' }} />}
            key={key}
            onClick={() => setSizeRangeIndex(index)}
            sx={{
              bgcolor: active ? '#ECFBF4' : undefined,
              borderColor: active ? '#2AC682' : '#DDE0E7',
              color: '#212121',
              width: display === 'column' ? '100%' : display === 'grid' ? '48%' : 'auto',
              minHeight: heavyButton ? 80 : 'auto',
              justifyContent: display === 'column' ? 'flex-start' : 'center',
            }}
            variant="outlined"
          >
            {t(max ? 'companies.size_dialog.count' : 'companies.size_dialog.count_no_max', {
              min,
              max,
            })}
          </Button>
        );
      })}
    </Box>
  );
}

export default SizeRangeForm;
